import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cn from 'classnames';
import { MENU_DESKTOP_ITEMS } from '../../constants/topMenu';
import * as style from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Menu = function Menu(props) {
  var activeIndex = props.activeIndex,
      onClick = props.onClick;
  return /*#__PURE__*/_jsx("div", {
    className: style['menu'],
    children: MENU_DESKTOP_ITEMS.map(function (item, index) {
      return /*#__PURE__*/_jsx("a", {
        href: item.href,
        className: cn(style['menu-item'], _defineProperty({}, style['menu-item--active'], activeIndex === index)),
        onClick: function (_onClick) {
          function onClick(_x) {
            return _onClick.apply(this, arguments);
          }

          onClick.toString = function () {
            return _onClick.toString();
          };

          return onClick;
        }(function (e) {
          return onClick(e, index, item.id);
        }),
        children: item.children
      }, item.href);
    })
  });
};